import React, {ReactElement, ReactNode, RefObject} from "react";

import {css, generateKeyId} from "/src/utils/utils";

import * as styles from "./card-layout.module.scss";

export type ColumnValue = "2" | "3" | "4";

interface CardLayoutProps {
  column: ColumnValue;
  items: Array<ReactNode>;
  classes?: string;
  ref?: RefObject<HTMLUListElement>;
}

const CardLayout = (props: CardLayoutProps): ReactElement | null => {
  const {items, column, classes, ref} = props;
  const now = React.useRef(Date.now());

  if (!items || !items.length) {
    return null;
  }

  return (
    <ul
      ref={ref}
      className={css(
        styles.cardLayout,
        styles[`cardLayout${column}`],
        classes!
      )}
    >
      {items.map((child: ReactNode, i: number) => {
        return (
          <li
            className={styles.cardLayout__item}
            key={generateKeyId(`card-layout-item-${i}-${now.current}`)}
          >
            {child}
          </li>
        );
      })}
    </ul>
  );
};

export default CardLayout;
